import { IconProps } from 'src/utils/icon';

const AlertIcon: React.FC<IconProps> = ({ size = 1, fill = 'black' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 5 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.520833 12.1529H1.04167V8.1938H0.520833C0.233177 8.1938 0 7.9484 0 7.64567V6.33645C0 6.03372 0.233177 5.78832 0.520833 5.78832H3.4375C3.72516 5.78832 3.95833 6.03372 3.95833 6.33645V12.1529H4.47917C4.76682 12.1529 5 12.3983 5 12.701V14.0102C5 14.3129 4.76682 14.5583 4.47917 14.5583H0.520833C0.233177 14.5583 0 14.3129 0 14.0102V12.701C0 12.3983 0.233177 12.1529 0.520833 12.1529ZM2.5 0.526306C1.46445 0.526306 0.625 1.40975 0.625 2.49956C0.625 3.58937 1.46445 4.47282 2.5 4.47282C3.53555 4.47282 4.375 3.58937 4.375 2.49956C4.375 1.40975 3.53552 0.526306 2.5 0.526306Z"
      fill={fill}
    />
  </svg>
);

export default AlertIcon;
